import useRBAC from "../hooks/useRBAC";

export default function RBAC({
  resource,
  access,
  children,
  fallback = null,
  disable = false
}) {
  const { hasAccess, loading } = useRBAC();

  if (loading) return null;

  const allowed = hasAccess(resource, access);

  // ❌ Hide completely
  if (!allowed && !disable) return fallback;

  // ⚠️ Disable instead of hide
  if (!allowed && disable) {
    return (
      <div style={{ opacity: 0.5, pointerEvents: "none" }}>
        {children}
      </div>
    );
  }

  return children;
}